import axios from 'axios';
import { useState, useEffect } from 'react'

import Container from '@/landing/component/container/nogap'

import Head from "@helper/seo/head"
import { HeadingOne, HeadingTwo } from '@/general/component/typography/landing'

import styled from 'styled-components'

type Props = {
	caption: string;
	label: string;
}

const Row = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-evenly;
`
const Column = styled.div`
	display: flex;
	flex-direction: column;
	/* height: 119px; */
	margin: 5em;
	padding: 1em;
	justify-content: center;
	align-items: center;
	@media (max-width:1050px){
		display: flex;
		flex-direction: column;
		img{
			margin: 0 auto;
			width: 90%;
			width: 50%;
		}
	}
`

const getUrl = () => {
	if (typeof window !== "undefined") {
		const sellonUrl = window.location.hostname;

		var url = ''
		if(sellonUrl == 'dev.sellon.net') {
			url = 'https://staging-id-cms.sellon.net/'
		} else if(sellonUrl == 'dev.sellon.store') {
			url = 'https://staging-id-cms.sellon.store/'
		} else if(sellonUrl == 'sellon.net') {
			url = 'https://cms-idmaster.sellon.net/'
		} else if(sellonUrl == 'sellon.store') {
			url = 'https://cms-idmaster.sellon.store/'
		} else if(sellonUrl == 'localhost') {
			url = 'https://staging-id-cms.sellon.net/'
		}

		return url
	}
}

function Containers ({ contents }) {
	
	var useUrl = getUrl();
	const searchParams = new URLSearchParams(window.location.search);
	
	if (searchParams.has('place_name')) {
		const place_name = searchParams.get('place_name')
		var url_query_param = '?place_name=' + place_name
	} else {
		var url_query_param = '?place_name=user'
	}

	useEffect(() => {
		// axios.get(useUrl + 'api_mobile/sellon_download//?place_name=' + place_name)
		axios.get(useUrl + 'api_mobile/sellon_download/click_link/' + url_query_param)
		.then(response => {
			// console.log(response.data) // ok
		})
		.catch(error => {
			// console.error(error);
		});

	}, []);

	const openPlaystore = () => {
		axios.get(useUrl + 'api_mobile/sellon_download/click_app_or_play_store/' + url_query_param + '&open_store=play_store')
		.then(response => {
			// console.log(response.data) // ok
		})
		.catch(error => {
			// console.error(error);
		});
    }

	const openAppstore = () => {
		axios.get(useUrl + 'api_mobile/sellon_download/click_app_or_play_store/' + url_query_param + '&open_store=app_store')
		.then(response => {
			// console.log(response.data) // ok
		})
		.catch(error => {
			// console.error(error);
		});
    }

	return (
		<Container>
			<Head
				title="SellOn | Download"
				type="website"
				url="https://sellon.net/download"
				siteName="Sellon Tech"
				image="/media/logo/main.png"
			/>
			<div className="
				flex flex-col gap-14
				text-center items-center
				mt-6
			">
				<HeadingOne>Download SellOn App</HeadingOne>
				<img className='w-28' src="/media/elements/separator-title.png" alt="separator" />
			</div>
			<Column style={{ margin: '5em 0' }}>
				<div style={{ margin: '-25px' }}></div>
				<img src={'/media/logo/sellon-old.png'} width="300px" alt="Sellon" />
				<div style={{ margin: '20px' }}></div>
				<a id='button_playstore' href="https://play.google.com/store/apps/details?id=com.csi.sellon" target="_blank" onClick={openPlaystore}><img src={'/media/logo/googleplay_button.png'} width="300px" alt="PlayStore" /></a>
				{/* <a id='button_playstore' href="https://play.google.com/store/apps/details?id=com.csi.sellon" target="_blank"><img src={'/media/logo/googleplay_button.png'} width="300px" alt="PlayStore" /></a> */}
				<div style={{ margin: '4px' }}></div>
				<a href="https://apps.apple.com/id/app/sellon-online-marketplace/id1462394563" target="_blank" onClick={openAppstore}><img src={'/media/logo/appstore_button.png'} width="300px" alt="AppStore" /></a>
				{/* <a href="https://apps.apple.com/id/app/sellon-online-marketplace/id1462394563" target="_blank"><img src={'/media/logo/appstore_button.png'} width="300px" alt="AppStore" /></a> */}
				<div className='mb-12'></div>
				<div className='-mb-20'></div>
			</Column>
		</Container>
	)
}
export default Containers